module.exports = __webpack_public_path__ + "static/media/loan-expired.b0f3dea9.svg";